module.exports = __webpack_public_path__ + "static/media/hamburger-menu-icon.57a48036.svg";